<template>
    <GroupTable :userId="userId" />
</template>

<script>
import GroupTable from './GroupTable.vue'

export default {
    props: {
        userId: {
            type: [Number, String, null],
            required: false,
            default: null,
        },
    },
    components: {
        GroupTable,
    },
}
</script>
